<template>
    <div>
        <div class="flex wrap center vcenter">
            <input type="text" placeholder="مبلغ سرمایه گذاری را وارد کنید" v-model="value" />
            <p>{{ hint }}</p>
        </div>
        <div v-if="!interest_rate" class="types flex wrap center vcenter">
            <button :class="{ 'selected': _base === 36 }" @click.prevent="() => {
                override_period = ''
                _base = 36
            }">طرح با تسویه سود به
                صورت دوره‌ای</button>
            <button :class="{ 'selected': _base === 42 }" @click.prevent="() => {
                override_period = 'پایان قرارداد'
                _base = 42
            }">طرح با
                تسویه پیش بینی سود در پایان قرارداد</button>
        </div>
        <div class="details flex wrap center vcenter">
            <div class="flex wrap center vcenter">
                <p>دوره قرارداد: {{ period || 0 }} ماه</p>
            </div>
            <div class="flex wrap center vcenter">
                <p>کل سود پیش بینی شده دوره: {{ _base }} درصد</p>
            </div>
            <div class="flex wrap center vcenter">
                <p>دوره تسویه سود: {{ override_period || (`${(dividend_period || 0)}`) }}</p>
            </div>
            <div v-if="false" class="flex wrap center vcenter">
                <p>پیش بینی سود هر دوره پروژه: {{ override_period ? result['total'] : result['period'] }} ریال</p>
            </div>
            <div v-if="!no_guarantee" class="flex wrap center vcenter">
                <p>ضمانت سرمایه گذاری: {{ guarantee || 'ضمانت نامه بانکی' }}</p>
            </div>
            <div class="flex wrap center vcenter">
                <p>پیش بینی سود کل دوره پروژه: {{ result['total'] }} ریال</p>
            </div>
        </div>
        <div class="flex wrap center vcenter">
            <a class="flex" :href="path">
                <button class="invest">همین حالا سرمایه‌گذاری کنید!</button>
            </a>
        </div>
    </div>
</template>

<script>
/* eslint-disable */

require('../assets/js/amount')

export default {
    name: 'Calculator',
    props: ['period', 'interest_rate', 'dividend_period', 'no_guarantee', 'guarantee', 'path'],
    data() {
        return {
            _base: this.interest_rate || 36,
            override_period: '',
            value: '',
            hint: '',
            result: { period: 0, total: 0 },
        }
    },
    watch: {
        _base(newBase, oldBase) {
            this.calculate()
        },
        value(newValue, oldValue) {
            this.calculate()
        }
    },
    methods: {
        calculate() {
            this.value = this.value.replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.hint = this.value.replace(/,/g, '').num2persian() + ' ریال'

            this.result['period'] = String(Math.round((Number(this.value.replaceAll(',', '')) * Number(this._base)) / 100 / Number(this.period || 12) * 3)).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.result['total'] = String(Math.round(Number(this.value.replaceAll(',', '')) * Number(this._base)) / 100).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
    }
}
</script>

<style scoped src="../assets/css/components/calculator.css"></style>